import { render, staticRenderFns } from "./SelectionWithQuantityDisplay.vue?vue&type=template&id=038b1388&scoped=true&"
import script from "./SelectionWithQuantityDisplay.vue?vue&type=script&lang=js&"
export * from "./SelectionWithQuantityDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b1388",
  null
  
)

export default component.exports